var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGotome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "152px",
    height: "93px",
    viewBox: "0 0 152 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-10.8%",
    y: "-19.7%",
    width: "121.5%",
    height: "139.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937254902   0 0 0 0 0.282352941   0 0 0 0 0.647058824  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.2101251%",
    y1: "35.0857988%",
    x2: "89.9439995%",
    y2: "64.9142012%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD5DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F756DF",
    offset: "53.8051792%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF95C6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.2101251%",
    y1: "33.6734694%",
    x2: "89.9439995%",
    y2: "66.3265306%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900DE9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82DBF",
    offset: "53.8051792%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7519D",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0405_Renew-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buy-Fish/Logout",
    transform: "translate(-1393.000000, -919.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    filter: "url(#filter-1)",
    transform: "translate(1404.000000, 930.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Combined-Shape-Copy",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 4,
    x: 0,
    y: 0,
    width: 130,
    height: 71,
    rx: 35.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4293821,22.0044499 L87.7757962,22.0051273 C89.5564748,22.0051273 91,23.4494029 91,25.2310071 C91,26.9914018 89.5906399,28.4224516 87.8392467,28.4562748 L75.181,28.456 L81.2637342,33.5322296 C82.7462326,34.7694122 82.8133808,37.0028865 81.4228214,38.325996 L81.3712968,38.3739928 L75.699062,43.5470624 L87.7437308,43.5470624 C89.5207092,43.5470624 90.9652403,44.9574126 90.999382,46.7100362 L91,46.7735312 C91,48.5342473 89.5766235,49.9655584 87.8078123,49.9993877 L87.7437308,50 L67.3530334,50 C64.4161978,50 62.993709,46.4620141 65.0834037,44.4597731 L65.1478049,44.3995744 L74.2400499,36.1074303 L67.546,30.522 L59.7003218,48.0902059 C58.6179535,50.5135198 55.247982,50.6578956 53.9530684,48.3672992 L53.9144682,48.2971417 L48.448436,38.0863666 L48.4484076,46.7740643 C48.4484076,48.534459 47.0390474,49.9655088 45.2876542,49.999332 L45.2242038,50 C43.4647238,50 42.0344174,48.5898514 42.0006119,46.8375477 L42,25.2310071 C42,21.9093553 46.3938824,20.7729784 48.0180478,23.6204222 L48.0664098,23.7079297 L56.4952426,39.45293 L63.0239111,24.8337821 C63.0949765,24.2550957 63.3248887,23.6891364 63.7195065,23.2036907 L63.7657423,23.1480721 C64.4495008,22.3436621 65.4452793,21.9532989 66.4293821,22.0044499 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotome);
export default __webpack_public_path__ + "static/media/gotome.c1833b1a0aed3a1daf5c893d2d28aae0.svg";
export { ForwardRef as ReactComponent };